import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Batteria56VPrestazioniEf({ idVariant = '', className }: Props) {
  return (
    <IconBase name="batteria56-v-prestazioni-ef" w={65.617} h={65.618} className={className}>
      <g transform="translate(-38 -37.882)">
        <g>
          <defs>
            <rect
              id={`batteria56vprestazionief_${idVariant}_SVGID_1_`}
              x="38"
              y="37.882"
              width="65.617"
              height="65.618"
            />
          </defs>
          <clipPath id={`batteria56vprestazionief_${idVariant}_SVGID_2_`}>
            <use xlinkHref={`#batteria56vprestazionief_${idVariant}_SVGID_1_`} overflow="visible" />
          </clipPath>
          <path
            clipPath={`url(#batteria56vprestazionief_${idVariant}_SVGID_2_)`}
            fill="#9D9D9C"
            d="M71.587,103.5c17.69,0,32.03-14.34,32.03-32.03
      		c0-17.689-14.34-32.03-32.03-32.03s-32.03,14.341-32.03,32.03C39.558,89.16,53.897,103.5,71.587,103.5"
          />
          <path
            clipPath={`url(#batteria56vprestazionief_${idVariant}_SVGID_2_)`}
            fill="#E3E5E8"
            d="M70.03,101.943c17.691,0,32.031-14.341,32.031-32.03
      		c0-17.69-14.34-32.031-32.031-32.031C52.34,37.882,38,52.223,38,69.913C38,87.603,52.34,101.943,70.03,101.943"
          />
          <path
            clipPath={`url(#batteria56vprestazionief_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M67.3,100.199c-1.11-0.618-1.279-0.966-1.135-2.24
      		c0.695-6.159,1.386-12.318,2.079-18.478c0.095-0.843,0.194-1.685,0.3-2.614h-0.711c-3.555,0-7.111,0.001-10.666,0
      		c-1.761-0.002-2.529-1.224-1.748-2.793c5.31-10.676,10.618-21.353,15.955-32.015c0.24-0.479,0.756-0.822,1.144-1.228h0.812
      		c1.038,0.483,1.266,1.319,1.139,2.391c-0.672,5.675-1.312,11.354-1.967,17.029c-0.172,1.496-0.354,2.99-0.528,4.485
      		c-0.015,0.13-0.002,0.262-0.002,0.446h0.638c3.729,0,7.457-0.004,11.186,0.002c1.174,0.002,1.855,0.673,1.703,1.675
      		c-0.039,0.261-0.152,0.518-0.273,0.755C79.902,78.09,74.582,88.563,69.231,99.022c-0.236,0.462-0.74,0.788-1.119,1.177H67.3z"
          />
          <path
            clipPath={`url(#batteria56vprestazionief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M74.095,96.487c0.44-0.873,0.848-1.679,1.257-2.483
      		c0.768-1.515,1.523-3.034,2.32-4.533c0.148-0.278,0.429-0.55,0.714-0.682c5.3-2.462,9.019-6.402,10.836-11.958
      		c2.137-6.535,1.114-12.662-2.929-18.228c-2.33-3.206-5.428-5.45-9.147-6.831c-0.144-0.053-0.282-0.115-0.469-0.19
      		c0.243-2.11,0.485-4.215,0.729-6.324c10.861,2.878,19.479,13.347,19.184,25.766C96.242,85.62,84.828,95.163,74.095,96.487"
          />
          <path
            clipPath={`url(#batteria56vprestazionief_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M63.946,89.446c-0.242,2.146-0.477,4.234-0.713,6.326
      		c-9.872-2.468-19.351-12.296-19.194-25.443c0.176-14.701,11.553-24.411,22.481-25.763c-0.06,0.155-0.101,0.295-0.165,0.423
      		c-1.091,2.194-2.174,4.392-3.29,6.573c-0.134,0.262-0.408,0.512-0.678,0.636c-5.966,2.754-9.967,7.25-11.435,13.656
      		c-1.82,7.945,0.536,14.677,6.669,20.047C59.455,87.506,61.589,88.633,63.946,89.446"
          />
        </g>
      </g>
    </IconBase>
  )
}

export default Batteria56VPrestazioniEf
